'use client';

import { c as _c } from "react/compiler-runtime";
import type { AddFactiiiAction, AddFactiiiState } from '@shared/utils/helpers/addFactiii/formState';
import { X } from 'lucide-react';
import type { Dispatch } from 'react';
import { useState } from 'react';
import Button from '../../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../../HOC/Modal';
import Input from '../../UI/Input';
import { t } from './parts';
type Props = {
  state: AddFactiiiState;
  dispatch: Dispatch<AddFactiiiAction>;
};
const RulesEditor = t0 => {
  const $ = _c(20);
  const {
    state,
    dispatch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      title: "",
      description: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [draft, setDraft] = useState(t1);
  const [showModal, setShowModal] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowModal(false);
      setDraft({
        title: "",
        description: ""
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  let t3;
  if ($[2] !== dispatch || $[3] !== draft.description || $[4] !== draft.title) {
    t3 = () => {
      dispatch({
        type: "addRule",
        rule: {
          id: Date.now(),
          title: draft.title.trim(),
          description: draft.description.trim()
        }
      });
      close();
    };
    $[2] = dispatch;
    $[3] = draft.description;
    $[4] = draft.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const save = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className={t.meta}>Guidance for people tagging this factiii. Human moderators enforce them; nothing is checked automatically.</p>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== dispatch || $[8] !== state.rules) {
    t5 = state.rules.length > 0 && <div className="space-y-1.5">{state.rules.map((rule, index) => <div key={rule.id} className="flex items-start justify-between gap-2.5 rounded-lg border border-ds-border-standard px-2.5 py-2"><div className="min-w-0"><p className={t.label}>{index + 1}. {rule.title}</p><p className={`mt-0.5 ${t.meta}`}>{rule.description}</p></div><button type="button" onClick={() => dispatch({
          type: "removeRule",
          id: rule.id
        })} className="shrink-0 rounded-md p-1 text-textSecondary transition-colors hover:bg-ds-border-standard hover:text-destructive" title="Remove rule"><X size={14} /></button></div>)}</div>;
    $[7] = dispatch;
    $[8] = state.rules;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button text="Add Rule" onClick={() => setShowModal(true)} variant="PRIMARY" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div className="space-y-2.5">{t4}{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== draft || $[14] !== save || $[15] !== showModal) {
    t8 = showModal && <Modal closeHandler={close}><ModalHeader><h2>New Factiii Rule</h2></ModalHeader><ModalContent><Input type="text" label="Title" inputClassName="text-sm" value={draft.title} onChange={title => setDraft({
          ...draft,
          title
        })} /><Input type="textarea" label="Description" inputClassName="text-sm" rows={4} value={draft.description} onChange={description => setDraft({
          ...draft,
          description
        })} /></ModalContent><ModalFooter><Button text="Cancel" variant="SECONDARY" borderTransparent={false} onClick={close} /><Button text="Save" onClick={save} disabled={!draft.title.trim() || !draft.description.trim()} /></ModalFooter></Modal>;
    $[13] = draft;
    $[14] = save;
    $[15] = showModal;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default RulesEditor;